module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/design/eraser-10406abdda11b9a5c6816df5556265a1.svg";